"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureCommentInput = exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _At = _interopRequireDefault(require("@react/react-spectrum/Icon/At"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _PinOff = _interopRequireDefault(require("@react/react-spectrum/Icon/PinOff"));

var _Mentions = _interopRequireDefault(require("../Mentions/Mentions"));

var _TooltipButton = _interopRequireDefault(require("../TooltipButton"));

var _UserCard = _interopRequireWildcard(require("../UserCard"));

var _constants = require("../../constants");

var _utils = require("../../lib/utils.js");

var _Textarea = _interopRequireDefault(require("./Textarea"));

var _CommentInput = _interopRequireDefault(require("./CommentInput.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reducer = function reducer(state, _ref) {
  var type = _ref.type,
      data = _ref.data;

  var newState = _objectSpread({}, state);

  switch (type) {
    case 'blur':
      newState = _objectSpread(_objectSpread({}, newState), {}, {
        cursorPosition: 0,
        hasFocus: false
      });
      break;

    case 'change':
      newState = _objectSpread(_objectSpread({}, newState), {}, {
        cursorPosition: data.cursorPosition,
        hasError: data.hasError,
        showRemainingCharacters: data.showRemainingCharacters,
        remainingCharacters: data.remainingCharacters,
        value: data.value
      });
      break;

    case 'focus':
      newState = _objectSpread(_objectSpread({}, newState), {}, {
        focusedAtLeastOnce: true,
        hasFocus: true
      });
      break;

    case 'keyUp':
      newState = _objectSpread(_objectSpread({}, newState), {}, {
        cursorPosition: data.cursorPosition,
        mentionData: data.mentionData
      });
      break;

    case 'updateAcceptedMentions':
      newState.acceptedMentions = data;
      break;

    case 'updateCursorPosition':
      newState.cursorPosition = data;
      break;

    case 'updateMentionData':
      newState.mentionData = data;
      break;

    case 'updateMentionKeyPress':
      newState.mentionKeyPress = data;
      break;

    case 'updateSelectedMentionIndex':
      newState.selectedMentionIndex = data;
      break;

    default:
  }

  return newState;
};

var CommentInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var allowCollapseOverride = _ref2.allowCollapseOverride,
      animationEnabled = _ref2.animationEnabled,
      annotationsEnabled = _ref2.annotationsEnabled,
      annotationTypes = _ref2.annotationTypes,
      className = _ref2.className,
      compactLayout = _ref2.compactLayout,
      defaultMentions = _ref2.defaultMentions,
      initialValue = _ref2.initialValue,
      intl = _ref2.intl,
      isAnnotating = _ref2.isAnnotating,
      mentionsEnabled = _ref2.mentionsEnabled,
      onAnnotationClick = _ref2.onAnnotationClick,
      onBlur = _ref2.onBlur,
      onClick = _ref2.onClick,
      onFocus = _ref2.onFocus,
      onHeightChange = _ref2.onHeightChange,
      onKeyUp = _ref2.onKeyUp,
      onMentionClick = _ref2.onMentionClick,
      onTextPresent = _ref2.onTextPresent,
      placeholder = _ref2.placeholder,
      richTextEntry = _ref2.richTextEntry,
      shouldFocusIfValueExists = _ref2.shouldFocusIfValueExists,
      touchControls = _ref2.touchControls;
  var formatMessage = intl.formatMessage;
  var commentInputRef = (0, _react.useRef)();
  var mentionRef = (0, _react.useRef)();
  var textareaActionBarRef = (0, _react.useRef)();
  var textareaRef = (0, _react.useRef)();

  var _useReducer = (0, _react.useReducer)(reducer, {
    acceptedMentions: defaultMentions,
    cursorPosition: 0,
    focusedAtLeastOnce: false,
    hasError: false,
    hasFocus: false,
    mentionData: {},
    mentionKeyPress: {},
    remainingCharacters: null,
    selectedMentionIndex: 0,
    showRemainingCharacters: false,
    value: initialValue
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      acceptedMentions = _useReducer2$.acceptedMentions,
      cursorPosition = _useReducer2$.cursorPosition,
      focusedAtLeastOnce = _useReducer2$.focusedAtLeastOnce,
      hasError = _useReducer2$.hasError,
      hasFocus = _useReducer2$.hasFocus,
      mentionData = _useReducer2$.mentionData,
      mentionKeyPress = _useReducer2$.mentionKeyPress,
      remainingCharacters = _useReducer2$.remainingCharacters,
      selectedMentionIndex = _useReducer2$.selectedMentionIndex,
      showRemainingCharacters = _useReducer2$.showRemainingCharacters,
      value = _useReducer2$.value,
      dispatch = _useReducer2[1];

  var getLimitErrors = (0, _react.useCallback)(function (updatedText) {
    var text = updatedText.trim(); // The length of the text will change when IDs are used instead of names. Use that length instead.

    var commentLength = mentionsEnabled ? (0, _utils.replaceNameWithID)(text, acceptedMentions).length : text.length;
    var newRemainingCharacters = _constants.COMMENT_TEXT_LIMIT - commentLength;
    return {
      hasError: commentLength > _constants.COMMENT_TEXT_LIMIT,
      showRemainingCharacters: newRemainingCharacters <= 10,
      remainingCharacters: newRemainingCharacters
    };
  }, [acceptedMentions, mentionsEnabled]);
  (0, _react.useEffect)(function () {
    if (initialValue) {
      var newCursorPosition = initialValue.length;
      var limitErrors = getLimitErrors(initialValue);
      onTextPresent && onTextPresent(initialValue, limitErrors.hasError);
      textareaRef.current.setText(initialValue, newCursorPosition, true);
      dispatch({
        type: 'updateCursorPosition',
        data: newCursorPosition
      });

      if (shouldFocusIfValueExists) {
        textareaRef.current.setFocus();
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  var getTextareaInputValue = (0, _react.useCallback)(function (shouldTrimWhitespace) {
    return shouldTrimWhitespace ? value.trim() : value;
  }, [value]);
  var handleAnimationEnd = (0, _react.useCallback)(function () {
    if (compactLayout) {
      onHeightChange();
    }
  }, [compactLayout, onHeightChange]);
  var handleBlur = (0, _react.useCallback)(function () {
    dispatch({
      type: 'blur'
    });
    onBlur && onBlur();
  }, [onBlur]);
  var handleChange = (0, _react.useCallback)(function (newValue, newCursorPosition) {
    var limitErrors = getLimitErrors(newValue);
    onTextPresent && onTextPresent(newValue, limitErrors.hasError);
    dispatch({
      type: 'change',
      data: {
        cursorPosition: newCursorPosition,
        hasError: limitErrors.hasError,
        showRemainingCharacters: limitErrors.showRemainingCharacters,
        remainingCharacters: limitErrors.remainingCharacters,
        value: newValue
      }
    });
  }, [getLimitErrors, onTextPresent]);
  var handleClick = (0, _react.useCallback)(function (evt) {
    if (!hasFocus && !compactLayout && !touchControls || !evt.target.closest('[data-annotation-button]')) {
      textareaRef.current.setFocus();
    }

    onClick && onClick();
  }, [compactLayout, hasFocus, onClick, touchControls]);
  var handleFocus = (0, _react.useCallback)(function (evt) {
    dispatch({
      type: 'focus'
    });
    onFocus(evt);
    requestAnimationFrame(function () {
      return dispatch({
        type: 'updateCursorPosition',
        data: textareaRef.current.getCursorPosition()
      });
    });
  }, [onFocus]);
  var handleKeyDown = (0, _react.useCallback)(function (evt) {
    if (mentionRef.current && mentionRef.current.getShowMentions()) {
      if (evt.keyCode === _constants.KEY_CODES.ENTER || evt.keyCode === _constants.KEY_CODES.UP || evt.keyCode === _constants.KEY_CODES.DOWN || evt.keyCode === _constants.KEY_CODES.ESCAPE) {
        evt.preventDefault();
        evt.persist();
        dispatch({
          type: 'updateMentionKeyPress',
          data: evt
        });
      }
    } else if ((0, _utils.isKeyboardSubmit)(evt)) {
      // Browsers swallow keyup events when metakey is pressed.
      // Fired from keydown for enter key to support cmd+enter to submit
      var limitErrors = getLimitErrors(value);
      onKeyUp && onKeyUp(evt, value.trim(), limitErrors.hasError);
    }
  }, [getLimitErrors, onKeyUp, value]);
  var handleKeyUp = (0, _react.useCallback)(function (evt, newCursorPosition, valueOverride) {
    var newValue = valueOverride !== undefined ? valueOverride : value;
    var limitErrors = getLimitErrors(newValue);
    onKeyUp && onKeyUp(evt, newValue, limitErrors.hasError); // hide the mention popover when the user is typing

    dispatch({
      type: 'keyUp',
      data: {
        cursorPosition: newCursorPosition,
        mentionData: _objectSpread(_objectSpread({}, mentionData), {}, {
          tooltipUser: null
        })
      }
    });
  }, [getLimitErrors, onKeyUp, mentionData, value]);
  var handleMentionChange = (0, _react.useCallback)(function (selectedIndex) {
    dispatch({
      type: 'updateSelectedMentionIndex',
      data: selectedIndex
    });
  }, []);
  var handleMentionIconClick = (0, _react.useCallback)(function (evt) {
    evt.preventDefault(); //bring textarea to focus for getCursorPosition to return correct position

    textareaRef.current.setFocus();
    var curCursorPosition = textareaRef.current.getCursorPosition();
    var lastChar = value.length > 0 ? value[curCursorPosition - 1] : '';
    var textToInsert = (0, _utils.isWhiteSpaceOrPunctuation)(lastChar) ? '@' : ' @';
    var curValue = value;

    if (lastChar === '@') {
      return;
    } // Remove the trailing new line so the @ character is placed in its palce instead of on the next line


    if (lastChar === '\n') {
      curValue = curValue.slice(0, -1);
      curCursorPosition -= 1;
    }

    var textArr = curValue.split('');
    textArr.splice(curCursorPosition, 0, textToInsert);
    textareaRef.current.setText(textArr.join(''), curCursorPosition + textToInsert.length);
    onMentionClick();
  }, [onMentionClick, value]);
  var handleMentionKeyDown = (0, _react.useCallback)(function (evt) {
    if (evt.keyCode === _constants.KEY_CODES.ENTER || evt.keyCode === _constants.KEY_CODES.SPACE) {
      handleMentionIconClick(evt);
    }
  }, [handleMentionIconClick]);
  var handlePinKeyDown = (0, _react.useCallback)(function (evt) {
    if (evt.keyCode === _constants.KEY_CODES.ENTER || evt.keyCode === _constants.KEY_CODES.SPACE) {
      onAnnotationClick(evt, 'pin');
    }
  }, [onAnnotationClick]);
  var handleMentionHover = (0, _react.useCallback)(function (evt, textareaEl) {
    if (evt) {
      var toElement = evt.toElement || evt.relatedTarget;
      var mentionId = toElement.dataset.structuredtextid;
      var mentionedUser = acceptedMentions.find(function (acceptedMention) {
        return acceptedMention.id === mentionId;
      });

      if (mentionedUser) {
        var user = {
          id: mentionedUser.id,
          name: mentionedUser.name,
          email: mentionedUser.email,
          img: mentionedUser.src,
          orgName: mentionedUser.orgName
        };
        var textareaRect = textareaEl.getBoundingClientRect();
        var rect = toElement.getBoundingClientRect();
        dispatch({
          type: 'updateMentionData',
          data: _objectSpread(_objectSpread({}, mentionData), {}, {
            mentionRect: rect,
            mentionOffsetLeft: toElement.offsetLeft,
            tooltipY: rect.bottom - textareaRect.top,
            tooltipUser: user
          })
        });
      }
    } else {
      dispatch({
        type: 'updateMentionData',
        data: _objectSpread(_objectSpread({}, mentionData), {}, {
          tooltipUser: null
        })
      });
    }
  }, [acceptedMentions, mentionData]);
  var handleUserCardRender = (0, _react.useCallback)(function (width) {
    var mentionRect = mentionData.mentionRect,
        mentionOffsetLeft = mentionData.mentionOffsetLeft;
    var textareaRect = commentInputRef.current.getBoundingClientRect();
    var centeredCarentPos = mentionOffsetLeft + mentionRect.width / 2;
    var left = Math.max(mentionOffsetLeft + mentionRect.width / 2 - width / 2, -12);
    var right = 'auto';
    var curTooltipLeft = centeredCarentPos - left;
    var curTooltipRight = 'auto';

    if (mentionRect.height > 20) {
      // Handle wrapping mention
      left = 'auto';
      right = 0;
      curTooltipLeft = 'auto';
      curTooltipRight = 0;
    } else if (left + width > textareaRect.width) {
      // Handle mention to close to the right edge
      var shiftAmount = left + width - textareaRect.width;
      left -= shiftAmount;
      curTooltipLeft += shiftAmount;
    }

    dispatch({
      type: 'updateMentionData',
      data: _objectSpread(_objectSpread({}, mentionData), {}, {
        tooltipLeft: left,
        tooltipRight: right,
        tooltipCaretLeft: curTooltipLeft,
        tooltipCaretRight: curTooltipRight
      })
    });
  }, [mentionData]);

  var _setTextareaInputValue = (0, _react.useCallback)(function (text, cursorPos, scrollToEnd) {
    textareaRef.current.setText(text, cursorPos, scrollToEnd);
    dispatch({
      type: 'updateCursorPosition',
      data: cursorPos
    });
  }, []);

  var updateAcceptedSuggestions = (0, _react.useCallback)(function (newAcceptedMentions) {
    dispatch({
      type: 'updateAcceptedMentions',
      data: newAcceptedMentions
    });
  }, []);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      clearTextareaInput: function clearTextareaInput() {
        return textareaRef.current.clearTextareaInput();
      },
      getAcceptedMentions: function getAcceptedMentions() {
        return acceptedMentions;
      },
      getComponentRef: function getComponentRef() {
        return commentInputRef.current;
      },
      getTextareaInputValue: getTextareaInputValue,
      setFocus: function setFocus() {
        return setTimeout(function () {
          return textareaRef.current.setFocus();
        }, 300);
      },
      // Bug: CCX-10166 - Delay focus until textarea is extended. Remove delay when textarea animation is removed.
      setTextareaInputValue: function setTextareaInputValue(newValue) {
        return _setTextareaInputValue(newValue, newValue.length, true);
      }
    };
  });
  var textareaInputClassNames = (0, _classnames.default)(_CommentInput.default.component, className, {
    'has-error': hasError
  });
  var showActionBar = annotationsEnabled && !annotationTypes || mentionsEnabled;
  var hasText = getTextareaInputValue().length > 0;
  var disableAnimation = animationEnabled && (hasText || allowCollapseOverride);
  var expand = hasFocus && animationEnabled;
  var tooltipCaretLeft = mentionData.tooltipCaretLeft,
      tooltipCaretRight = mentionData.tooltipCaretRight,
      tooltipLeft = mentionData.tooltipLeft,
      tooltipRight = mentionData.tooltipRight,
      tooltipUser = mentionData.tooltipUser,
      tooltipY = mentionData.tooltipY;
  var mentionPopover = {
    top: "".concat(tooltipY, "px"),
    left: tooltipLeft,
    right: tooltipRight,
    zIndex: 1000
  };
  var arrowStyle = {
    left: tooltipCaretLeft,
    right: tooltipCaretRight
  };
  var textareaAriaAttributes = (0, _react.useMemo)(function () {
    if (selectedMentionIndex < 0) {
      return {
        'aria-expanded': false
      };
    }

    return {
      'aria-expanded': true,
      'aria-activedescendant': "suggestion-".concat(selectedMentionIndex)
    };
  }, [selectedMentionIndex]);
  var structuredText = (0, _react.useMemo)(function () {
    return acceptedMentions && acceptedMentions.map(function (mention) {
      return {
        class: 'mention',
        id: mention.id,
        text: "@".concat(mention.name)
      };
    });
  }, [acceptedMentions]);
  var mentionLabel = formatMessage({
    id: 'comments.textarea_input.mention.tooltip'
  });
  var pinLabel = formatMessage({
    id: 'comments.textarea_input.pin.tooltip'
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: textareaInputClassNames,
    ref: commentInputRef,
    onAnimationEnd: handleAnimationEnd
  }, mentionsEnabled && /*#__PURE__*/_react.default.createElement(_Mentions.default, {
    cursorIndex: cursorPosition,
    defaultMentions: defaultMentions,
    keyPress: mentionKeyPress,
    onAcceptedSuggestionsChange: updateAcceptedSuggestions,
    onTextValueChange: _setTextareaInputValue,
    onChange: handleMentionChange,
    ref: mentionRef,
    textValue: value
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('textbox', {
      focus: hasFocus,
      'has-text': hasText,
      'disable-animation': disableAnimation,
      'no-action-bar': showActionBar,
      expand: expand,
      collapse: !expand && focusedAtLeastOnce && animationEnabled
    }),
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_Textarea.default, {
    ariaAttributes: textareaAriaAttributes,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onStructuredTextHover: handleMentionHover,
    placeholder: formatMessage({
      id: placeholder || 'comments.submit.placeholder'
    }),
    ref: textareaRef,
    richTextEntry: richTextEntry,
    structuredText: structuredText
  }), tooltipUser && /*#__PURE__*/_react.default.createElement(_UserCard.UserCardPopover, {
    style: mentionPopover,
    arrowStyle: arrowStyle,
    trapFocus: false,
    placement: "bottom"
  }, /*#__PURE__*/_react.default.createElement(_UserCard.default, {
    user: tooltipUser,
    onRender: handleUserCardRender
  })), showActionBar && /*#__PURE__*/_react.default.createElement("div", {
    className: "action-bar-container",
    ref: textareaActionBarRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "action-bar".concat(showRemainingCharacters ? ' remaining-characters-visible' : '')
  }, mentionsEnabled && !compactLayout && (touchControls ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-label": mentionLabel,
    "data-test": "mention-button-touch",
    className: "tool-button",
    icon: /*#__PURE__*/_react.default.createElement(_At.default, null),
    variant: "tool",
    onMouseDown: handleMentionIconClick
  }) : /*#__PURE__*/_react.default.createElement(_TooltipButton.default, {
    "aria-label": mentionLabel,
    "data-test": "mention-button",
    className: "tool-button",
    icon: /*#__PURE__*/_react.default.createElement(_At.default, null),
    placement: "bottom",
    tooltip: mentionLabel,
    onMouseDown: handleMentionIconClick,
    onKeyDown: handleMentionKeyDown
  })), annotationsEnabled && !annotationTypes && (touchControls ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    "aria-label": pinLabel,
    "data-annotation-button": true,
    "data-test": "pin-button-touch",
    className: "tool-button",
    icon: /*#__PURE__*/_react.default.createElement(_PinOff.default, null),
    variant: "tool",
    onMouseDown: compactLayout ? undefined : function (event) {
      return onAnnotationClick(event, 'pin');
    },
    onClick: compactLayout ? function (event) {
      return onAnnotationClick(event, 'pin');
    } : undefined,
    selected: isAnnotating
  }) : /*#__PURE__*/_react.default.createElement(_TooltipButton.default, {
    "aria-label": pinLabel,
    "data-annotation-button": true,
    "data-test": "pin-button",
    className: "tool-button",
    icon: /*#__PURE__*/_react.default.createElement(_PinOff.default, null),
    placement: "bottom",
    tooltip: pinLabel,
    onKeyDown: handlePinKeyDown,
    onMouseDown: function onMouseDown(event) {
      return onAnnotationClick(event, 'pin');
    },
    selected: isAnnotating
  }))))), showRemainingCharacters ? /*#__PURE__*/_react.default.createElement("div", {
    id: "ccx-comment-textarea-message",
    className: "remaining-characters"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.textarea_input.remaining",
    values: {
      num: remainingCharacters.toString()
    }
  })) : null);
});
exports.PureCommentInput = CommentInput;
CommentInput.displayName = 'CommentInput';
CommentInput.defaultProps = {
  initialValue: '',
  shouldFocusIfValueExists: true
};
CommentInput.propTypes = {
  allowCollapseOverride: _propTypes.default.bool,
  animationEnabled: _propTypes.default.bool,
  annotationsEnabled: _propTypes.default.bool,
  annotationTypes: _propTypes.default.shape({
    draw: _propTypes.default.bool,
    pin: _propTypes.default.bool,
    text: _propTypes.default.bool
  }),
  className: _propTypes.default.string,
  compactLayout: _propTypes.default.bool,
  defaultMentions: _propTypes.default.array,
  initialValue: _propTypes.default.string,
  intl: _propTypes.default.object,
  isAnnotating: _propTypes.default.bool,
  mentionsEnabled: _propTypes.default.bool,
  onAnnotationClick: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onClick: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onKeyUp: _propTypes.default.func,
  onHeightChange: _propTypes.default.func,
  onMentionClick: _propTypes.default.func,
  onTextPresent: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  richTextEntry: _propTypes.default.bool,
  shouldFocusIfValueExists: _propTypes.default.bool,
  touchControls: _propTypes.default.bool
};

var _default = (0, _reactIntl.injectIntl)(CommentInput, {
  forwardRef: true
});

exports.default = _default;